import React, { useEffect } from 'react'
import styled from 'styled-components'
import api from '../../api'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
import { Container } from '../../assets/styles/GlobalStyle'
import AppDownloadSection from '../../components/AppDownloadSection'
import Loader from '../../components/Loader'
import TeammateCard from '../../components/TeammateCard'
import { AboutUsType } from '../../domain/types'
import { useAppSelector } from '../../store'
import FindAnswerBanner from '../../components/v2/FindAnswerBanner'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { AppState } from '../../store/appSlice'
//
//
const AboutUs = () => {
  //
  const { t } = useTranslation()
  //
  const { data, isLoading: isOurTeamLoading } = api.useGetWebPageQuery('about-us')
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const ourTeam: AboutUsType = data as AboutUsType
  //
  // scroll to top
  useEffect(() => {
    window.scrollTo(0, 0)
    //
    return () => {}
  }, [])
  //
  //
  return isOurTeamLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      {/* FOR SEO */}
      <Helmet>
        <title>{t('aboutUsSeoTitle')}</title>
        <meta name="description" content={`${t('aboutUsSeoDescription')}`} />
        <meta name="keywords" content="ჩვენს შესახებ, ფრანი, სადაზღვევო ბროკერი" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/* FOR SEO */}
      <Container>
        <PageTitle>{ourTeam?.translations?.[lang]?.body}</PageTitle>
        <PageDescription>{ourTeam?.translations?.[lang]?.excerpt}</PageDescription>

        <SliderBlock>
          {ourTeam && ourTeam.children && ourTeam.children.length >= 1 ? (
            <>
              {ourTeam.children.map((item, index) => (
                <TeammateCard
                  key={index}
                  imgUrl={item.image}
                  fullName={item.translations?.[lang]?.title}
                  position={item.translations?.[lang]?.excerpt}
                  linkUrl={item.url}
                />
              ))}
            </>
          ) : null}
        </SliderBlock>

        <FindAnswerBanner isFrani={true} />
      </Container>
      <AppDownloadSection />
    </Wrapper>
  )
}
//
// styles
const PageTitle = styled.h2`
  text-align: center;
  font-size: 48px;
  color: ${Colors.primaryBlack};
  margin-bottom: 24px;
`
const PageDescription = styled.h2`
  font-size: 18px;
  width: 70%;
  text-align: center;
  margin-inline: auto;
  color: ${Colors.nevadaGrey};
  margin-bottom: 65px;

  ${Responsive.tablet} {
    margin-bottom: 32px;
  }
  ${Responsive.mobile} {
    margin-bottom: 32px;
  }
`
const SliderBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(336px, 1fr));
  gap: 62px 47px;

  ${Responsive.tablet} {
    gap: 20px;
  }

  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
    gap: 20px;
  }
`
const Wrapper = styled.div`
  padding-block: 70px;
  background-color: ${Colors.blackHaze};
`
//
export default AboutUs
